import { apiGet, apiPost, apiPatch, apiDelete } from './client.js';

export type WalkInQueueReason =
  | 'walk_in'
  | 'pickup'
  | 'appointment'
  | 'dropoff'
  | 'question';

export type StaffQueueEntry = {
  id: string;
  displayName: string;
  customerId: string | null;
  ticketId: string | null;
  appointmentId: string | null;
  reason: string;
  notes: string | null;
  deviceLabel: string | null;
  status: string;
  assignedTo: string | null;
  assignedToName: string | null;
  queueNumber: number;
  queuedAt: string;
  calledAt: string | null;
  completedAt: string | null;
  priority: number;
  ticketNumber: string | null;
  waitingMinutes: number;
};

export type WalkInQueueBoard = {
  serving: StaffQueueEntry[];
  waiting: StaffQueueEntry[];
};

export const walkInQueueApi = {
  status: () =>
    apiGet<{ enabled: boolean; waitingCount: number; servingCount: number }>(
      '/api/v1/walk-in-queue/status',
    ).then((r) => r.data),

  list: () => apiGet<WalkInQueueBoard>('/api/v1/walk-in-queue').then((r) => r.data),

  add: (body: {
    displayName: string;
    customerId?: string | null;
    ticketId?: string | null;
    appointmentId?: string | null;
    reason?: WalkInQueueReason;
    notes?: string | null;
    deviceLabel?: string | null;
  }) => apiPost('/api/v1/walk-in-queue', body).then((r) => r.data),

  update: (
    id: string,
    body: Partial<{
      displayName: string;
      reason: WalkInQueueReason;
      notes: string | null;
      deviceLabel: string | null;
      priority: number;
      ticketId: string | null;
    }>,
  ) => apiPatch(`/api/v1/walk-in-queue/${id}`, body).then((r) => r.data),

  call: (id: string) => apiPost(`/api/v1/walk-in-queue/${id}/call`).then((r) => r.data),

  complete: (id: string) => apiPost(`/api/v1/walk-in-queue/${id}/complete`).then((r) => r.data),

  abandon: (id: string) => apiPost(`/api/v1/walk-in-queue/${id}/abandon`).then((r) => r.data),

  remove: (id: string) => apiDelete(`/api/v1/walk-in-queue/${id}`),

  reorder: (id: string, direction: 'up' | 'down') =>
    apiPost(`/api/v1/walk-in-queue/${id}/reorder`, { direction }).then((r) => r.data),
};
